import { get, post } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  disconnectStripeAccountFailed,
  disconnectStripeAccountSuccess,
  getConnectedAccountsConfigFailed,
  getConnectedAccountsConfigSuccess,
  getConnectedAccountsListFailed,
  getConnectedAccountsListSuccess,
  getStripeConnectedAccountFailed,
  getStripeConnectedAccountSuccess,
  hideDisconnectStripeAccountModal,
  savePayoutsFailed,
  savePayoutsSuccess,
  setStripeMainAccountFailed,
  setStripeMainAccountSuccess,
} from "./actions"
import {
  DISCONNECT_STRIPE_ACCOUNT,
  GET_CONNECTED_ACCOUNTS_CONFIG,
  GET_CONNECTED_ACCOUNTS_LIST,
  GET_STRIPE_CONNECTED_ACCOUNT,
  SAVE_PAYOUTS,
  SET_STRIPE_MAIN_ACCOUNT,
} from "./actionTypes"
import * as url from "helpers/url_helper"

function* getConnectedAccountsConfig({ payload: params }) {
  try {
    const response = yield get("/admin/stripe/connected-accounts/config", {
      params,
    })
    yield put(getConnectedAccountsConfigSuccess(response))
  } catch (error) {
    yield put(getConnectedAccountsConfigFailed(error))
    showToast("error", error, "Error")
  }
}

function* getConnectedAccountsList({ payload: params }) {
  try {
    const response = yield get("/admin/stripe/connected-accounts-list")
    yield put(getConnectedAccountsListSuccess(response))
  } catch (error) {
    yield put(getConnectedAccountsListFailed(error))
    showToast("error", error, "Error")
  }
}

function* savePayouts({ payload: params }) {
  try {
    const response = yield post(
      "/admin/stripe/connected-accounts/config",
      params
    )
    yield put(savePayoutsSuccess(response))
    showToast("success", "Payous saved!", "Success")
  } catch (error) {
    yield put(savePayoutsFailed(error))
    showToast("error", error, "Error")
  }
}

function* setStripeMainAccount({ payload: { values, callback } }) {
  try {
    const response = yield post("/admin/stripe/set-main-account", values)
    yield put(setStripeMainAccountSuccess(response))
    if (callback) {
      callback()
    }
    showToast("success", "Main account set!")
  } catch (error) {
    yield put(setStripeMainAccountFailed(error))
    showToast("error", error, "Error")
  }
}

function* disconnectStripeAccount({ payload: params }) {
  try {
    const response = yield post("/admin/stripe/disconnect", params)
    yield put(disconnectStripeAccountSuccess(params))
    yield put(hideDisconnectStripeAccountModal())
    showToast("success", "Account disconnected!", "Success")
  } catch (error) {
    yield put(disconnectStripeAccountFailed(error))
    yield put(hideDisconnectStripeAccountModal())
    showToast("error", error, "Error")
  }
}

function* getStripeConnectedAccount({ payload: params }) {
  try {
    const response = yield get(url.STRIPE_CONNECTED_ACCOUNT_URL, { params })
    yield put(getStripeConnectedAccountSuccess(response))
  } catch (error) {
    yield put(getStripeConnectedAccountFailed(error))
    showToast("error", error, "Error")
  }
}

function* payoutsSaga() {
  yield takeEvery(GET_CONNECTED_ACCOUNTS_CONFIG, getConnectedAccountsConfig)
  yield takeEvery(GET_CONNECTED_ACCOUNTS_LIST, getConnectedAccountsList)
  yield takeEvery(SAVE_PAYOUTS, savePayouts)
  yield takeEvery(SET_STRIPE_MAIN_ACCOUNT, setStripeMainAccount)
  yield takeEvery(DISCONNECT_STRIPE_ACCOUNT, disconnectStripeAccount)
  yield takeEvery(GET_STRIPE_CONNECTED_ACCOUNT, getStripeConnectedAccount)
}

export default payoutsSaga
